import axios_nomura from './axios-nomura.services';

export const fetchCalendarByDate = async (data) => {
  return await axios_nomura.get(`api/v1/calendars`, { params: { startAt: data.startAt ?? '', endAt: data.endAt ?? '', fundId: data.fundId } });
};

export const fetchCalendarByYear = async (data) => {
  return await axios_nomura.get(`api/v1/calendars/summary`, { params: { startAt: data.startAt ?? '', endAt: data.endAt ?? '', fundId: data.fundId } });
};

export const fetchCalendarThaiHolidays = async () => {
  return await axios_nomura.get(`api/v1/calendars/thailand_holidays`);
};